/* eslint-disable import/no-unresolved */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import SearchFilterVehiculos from 'src/components/leads/searchFilterVehiculos';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import VehiculoDetails from 'src/components/leads/vehiculoDetails/VehiculoDetails';
import { useStyles } from './styles';
import TableType4 from '@auteco/components/sharedComponents/Tablas/TableType4/TableType4';
import VehiculosAdd from '@auteco/components/leads/vehiculos/VehiculosAdd';

const VehiculosPage = (props) => {
  const classes = useStyles();

  const {
    form,
    isEdit,
    details,
    controls,
    vehiculos,
    marcas,
    unidadNegocios,
    onOpenForm,
    onCloseForm,
    openDetails,
    permitValue,
    openAddForm,
    handleSubmit,
    handleChange,
    handleDelete,
    onOpenDetails,
    controlComponent,
    onChangeInputs
  } = props;

  const columnsLeads = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      hidden: true,
    },
    {
      title: 'UNIDAD DE NEGOCIO',
      field: 'nombre_unidad_negocio',
      editable: 'never',
    },
    {
      title: 'MARCA',
      field: 'marca',
      editable: 'never',
    },
    { title: 'LINEA', field: 'linea', editable: 'never' },
    
    {
      title: 'ESTADO',
      field: 'estado',
      render: (rowData) => <td> {rowData.estado === "1" ? "Activo " : "Desactivado "}</td>
    }
  ];

  return (
    <>
      <CardTitle title="Vehiculos Leads" />

      {openAddForm && (
        <VehiculosAdd
          form={form}
          isEdit={isEdit}
          controls={controls}
          onClose={onCloseForm}
          vehiculos={vehiculos}
          marcas={marcas}
          unidadNegocios={unidadNegocios}
          handleSubmit={handleSubmit}
          openAddToSocio={openAddForm}
          onChangeInputs={onChangeInputs}
        />
      )}
      {permitValue >= 2 ? (
        <Button color="warning" onClick={onOpenForm} className={classes.button}>
          Agregar Vehículo
        </Button>
      ) : null}

      <SearchFilterVehiculos
        lineas={vehiculos}
        handleChange={handleChange}
        unidadNegocios={unidadNegocios}
        marcas={marcas}
        controlComponent={controlComponent}
      />

      <TableType4
        hiddenDelete={permitValue < 4}
        hiddenEdit={permitValue < 3}
        onOpenDetails={onOpenDetails}
        pageSize={15}
        columns={columnsLeads}
        openForm={onOpenForm}
        onDelete={handleDelete}
        title="Vehiculos"
        dataTable={vehiculos}
      />

      <VehiculoDetails
        details={details}
        onClose={onCloseForm}
        openDetails={openDetails}
      />
    </>
  );
};

export default VehiculosPage;
